"use strict";
/**
 * User Database Record Types
 *
 * Based on actual DynamoDB schema and backend implementation
 * Source: CDK data-models.ts (validated)
 */
Object.defineProperty(exports, "__esModule", { value: true });
